export enum CartUpdateType {
  MEMORY = 'MEMORY',
  CART = 'CART',
}
